export default {
  init() {
    // JavaScript to be fired on all pages
	$.scrollIt({
		upKey: 38,             // key code to navigate to the next section
		downKey: 40,           // key code to navigate to the previous section
		easing: 'linear',      // the easing function for animation
		scrollTime: 100,       // how long (in ms) the animation takes
		activeClass: 'current', // class given to the active nav element
		onPageChange: null,    // function(pageIndex) that is called when page is changed
		topOffset: -120,           // offste (in px) for fixed top navigation
	});
	(function() {
	var elements = document.querySelectorAll('img[data-src]');
	var index = 0;
	var lazyLoad = function() { 
	if(index >= elements.length) return;
	var item = elements[index]; 
	if((this.scrollY + this.innerHeight) > item.offsetTop) { 
	var src = item.getAttribute('data-src');
	item.src = src;
	item.addEventListener('load', function() {
	item.removeAttribute('data-src');     
	});     
	index++;
	lazyLoad();
	}
	};
	var init = function() {
	window.addEventListener('scroll', lazyLoad);
	lazyLoad();
	};
	return init();
	})();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    const menuToggle = document.getElementById('menuToggle');
    const body = document.querySelector('body');
    const anchorLink = document.querySelectorAll('.sub-nav-item');
    //const subNav = document.getElementByClass('sub-nav');

    menuToggle.addEventListener('click', function() {
      body.classList.toggle('nav-toggled');
      document.querySelector('html').classList.toggle('no-scroll');
    });
    
    //anchorLink[0].classList.add('current');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js